import QRCode from "qrcode";
import { expandCombos } from "./combos";
const AREA = {
  mesa: "MESA", rapida: "VENTA RÁPIDA", llamada: "PEDIDO LLAMADA", whatsapp: "PEDIDO WHATSAPP",
  ubereats: "UBER EATS", didi: "DIDI FOOD", rappi: "RAPPI", kiosko: "AUTOCOBRO", online: "PÁGINA WEB",
};
const money = (n) => `$${(n || 0).toFixed(2)}`;

function fulfillmentBlock(order) {
  if (order.order_type === "online") {
    const a = order.address || {};
    return `<div class="tag">PÁGINA WEB · A DOMICILIO</div>
      <div class="addr"><b>${a.nombre || order.customer_name || ""}</b><br/>
      Tel: ${order.phone || ""}<br/>
      ${a.calle || ""} ${a.numero || ""}<br/>
      Col. ${a.colonia || ""}<br/>
      ${a.referencia ? `Ref: ${a.referencia}<br/>` : ""}
      ${order.repartidor_name ? `REPARTIDOR: ${order.repartidor_name}` : ""}</div>`;
  }
  if (order.fulfillment === "recoger") {
    return `<div class="tag">PARA RECOGER</div><div class="big">${order.customer_name || ""}</div>${order.phone ? `<div class="ph">Tel: ${order.phone}</div>` : ""}`;
  }
  if (order.fulfillment === "llevar") {
    const a = order.address || {};
    return `<div class="tag">A DOMICILIO (ENVÍO)</div>
      <div class="addr"><b>${a.nombre || order.customer_name || ""}</b><br/>
      ${a.calle || ""} ${a.numero || ""}<br/>
      Col. ${a.colonia || ""}<br/>
      ${a.referencia ? `Ref: ${a.referencia}<br/>` : ""}
      Tel: ${order.phone || ""}</div>
      ${order.repartidor_name ? `<div class="tag">REPARTIDOR: ${order.repartidor_name}</div>` : ""}`;
  }
  if (order.customer_name) return `<div class="big">${order.customer_name}</div>`;
  return "";
}

function baseStyles(size) {
  const is58 = size === "58";
  const page = is58 ? "58mm" : "80mm";
  const width = is58 ? "48mm" : "72mm";
  const fs = is58 ? "12px" : "14px";
  return `
    @page { size:${page} auto; margin:0; }
    html,body{margin:0;padding:0}
    * { font-family: 'Arial Black', Arial, sans-serif; color:#000; box-sizing:border-box; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
    body { width:${width}; max-width:${width}; margin:0 auto; padding:2mm; font-size:${fs}; font-weight:700; word-wrap:break-word; overflow-wrap:break-word; }
    .center{text-align:center}
    .logo{max-width:60%;max-height:70px;margin:0 auto 4px;display:block}
    .biz{font-size:${is58?"16px":"18px"};font-weight:900}
    .muted{font-size:${is58?"11px":"12px"};font-weight:700}
    hr{border:none;border-top:2px dashed #000;margin:6px 0}
    .tag{font-size:${is58?"14px":"16px"};font-weight:900;text-align:center;border:2px solid #000;padding:3px;margin:4px 0}
    .big{font-size:${is58?"20px":"24px"};font-weight:900;text-align:center;text-transform:uppercase;margin:4px 0}
    .ph{text-align:center}
    .addr{font-size:${is58?"12px":"14px"};line-height:1.35;margin:4px 0}
    table{width:100%;table-layout:fixed;border-collapse:collapse;font-size:${fs};font-weight:800}
    td{padding:2px 0;vertical-align:top;word-wrap:break-word;overflow-wrap:break-word}
    td.q{width:22px} td.p{text-align:right;white-space:nowrap;width:64px}
    .mods{font-size:${is58?"11px":"12px"};font-weight:700}
    .meta{font-size:${is58?"11px":"12px"};font-weight:700;display:flex;justify-content:space-between;margin:1px 0}
    .box{border:2px solid #000;border-radius:6px;padding:6px 8px;margin-top:6px}
    .row{display:flex;justify-content:space-between;align-items:center}
    .sub{font-size:${is58?"12px":"13px"};font-weight:700}
    .total{font-size:${is58?"18px":"22px"};font-weight:900;display:flex;justify-content:space-between;align-items:center}
    .pay{font-size:${is58?"12px":"13px"};font-weight:700;display:flex;justify-content:space-between;margin-top:2px}
    .acct{font-size:${is58?"14px":"16px"};font-weight:900;text-align:center;background:#000;color:#fff;padding:4px;border-radius:4px;margin:6px 0}
    .foot{text-align:center;margin-top:8px;font-size:${is58?"11px":"13px"}}
  `;
}

export function openAndPrint(html) {
  // 1) Preferir ventana emergente: se imprime y cierra sola, NO bloquea/congela la app principal.
  try {
    const w = window.open("", "_blank", "width=400,height=640");
    if (w) {
      w.document.open();
      w.document.write(
        html +
        "<scr" + "ipt>window.onload=function(){setTimeout(function(){try{window.focus();window.print();}catch(e){}},200);};" +
        "window.onafterprint=function(){window.close();};setTimeout(function(){try{window.close();}catch(e){}},60000);</scr" + "ipt>"
      );
      w.document.close();
      return;
    }
  } catch (e) { /* popup bloqueado -> usar iframe */ }

  // 2) Respaldo: iframe oculto. Se limpia SOLO al terminar la impresión (onafterprint),
  //    nunca mientras el diálogo sigue abierto (eso causaba el congelamiento).
  try {
    const iframe = document.createElement("iframe");
    iframe.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden;";
    iframe.onload = () => {
      const win = iframe.contentWindow;
      let done = false;
      const cleanup = () => { if (done) return; done = true; try { iframe.remove(); } catch (e) { /* ignore */ } };
      try {
        win.onafterprint = cleanup;
        win.focus();
        win.print();
      } catch (e) { cleanup(); return; }
      setTimeout(cleanup, 60000);
    };
    document.body.appendChild(iframe);
    iframe.srcdoc = html;
  } catch (e) {
    console.warn("print skipped", e);
  }
}

const FONT_SCALE = { chico: 0.82, mediano: 1, grande: 1.18 };

export function ticketStyles(size, font = "mediano") {
  const is58 = size === "58";
  const page = is58 ? "58mm" : "80mm";
  const width = is58 ? "50mm" : "74mm";
  const k = (is58 ? 0.85 : 1) * (FONT_SCALE[font] || 1);
  const px = (n) => `${Math.round(n * k)}px`;
  return `
    @page { size:${page} auto; margin:0; }
    html,body{margin:0;padding:0}
    * { font-family: 'Arial Black', Arial, sans-serif; color:#000; box-sizing:border-box; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
    body { width:${width}; max-width:${width}; margin:0 auto; padding:3mm 1.5mm 14mm; font-size:${px(16)}; font-weight:700; line-height:1.3; word-wrap:break-word; overflow-wrap:break-word; }
    .copy{page-break-after:always} .copy:last-child{page-break-after:auto}
    .center{text-align:center}
    .logo{display:block;width:92%;max-height:${is58 ? "38mm" : "48mm"};object-fit:contain;margin:0 auto 8px}
    .biz{font-size:${px(24)};font-weight:900;text-transform:uppercase;letter-spacing:.5px;margin-top:2px}
    .muted{font-size:${px(14)};font-weight:700;margin-top:2px}
    hr{border:none;border-top:2px dashed #000;margin:10px 0}
    hr.solid{border-top:3px solid #000}
    .doc{font-size:${px(20)};font-weight:900;text-align:center;letter-spacing:2px;margin:8px 0 4px}
    .tag{font-size:${px(17)};font-weight:900;text-align:center;border:2px solid #000;padding:4px;margin:6px 0}
    .big{font-size:${px(26)};font-weight:900;text-align:center;text-transform:uppercase;margin:6px 0}
    .ph{text-align:center;font-size:${px(15)}}
    .addr{font-size:${px(15)};line-height:1.4;margin:6px 0}
    .meta{font-size:${px(15)};font-weight:800;display:flex;justify-content:space-between;gap:6px;margin:3px 0}
    .thead{display:flex;gap:6px;font-size:${px(12)};font-weight:900;border-bottom:2px solid #000;padding-bottom:3px;margin-bottom:3px}
    .it{display:flex;gap:6px;padding:3px 0;border-bottom:1px dotted #000;font-size:${px(14)};font-weight:800;line-height:1.2;align-items:flex-start}
    .it .q{min-width:30px} .it .n{flex:1} .it .p{white-space:nowrap;text-align:right}
    .mods{font-size:${px(12)};font-weight:700;margin-top:1px}
    .sep{border-top:3px double #000;margin:6px 0}
    .box{border:2px solid #000;border-radius:8px;padding:6px 8px;margin-top:8px}
    .row{display:flex;justify-content:space-between;align-items:center}
    .sub{font-size:${px(14)};font-weight:800;margin:2px 0}
    .total{font-size:${px(22)};font-weight:900;display:flex;flex-wrap:wrap;gap:0 6px;justify-content:space-between;align-items:center;border-top:2px solid #000;margin-top:4px;padding-top:4px}
    .pay{font-size:${px(14)};font-weight:800;display:flex;justify-content:space-between;margin-top:3px}
    .acct{font-size:${px(19)};font-weight:900;text-align:center;background:#000;color:#fff;padding:6px;border-radius:4px;margin:10px 0}
    .foot{text-align:center;margin-top:14px;font-size:${px(17)};font-weight:900}
    .qrbox{text-align:center;margin-top:12px;border-top:2px dashed #000;padding-top:10px}
    .qrtxt{font-size:${px(16)};font-weight:900;text-transform:uppercase;margin-bottom:6px}
    .qr{width:${is58 ? "32mm" : "40mm"};height:${is58 ? "32mm" : "40mm"};display:block;margin:0 auto}
    .qrurl{font-size:${px(12)};margin-top:4px;word-break:break-all}
    .copylbl{text-align:center;font-size:${px(12)};margin-top:8px}
  `;
}

function ticketBody(s, order, copyLabel) {
  const paid = !!order.paid;
  const isAccount = !paid && (order.state === "por_cobrar" || order.order_type === "mesa");
  const isMesa = order.order_type === "mesa";
  const when = new Date(order.created_at || Date.now());
  const rows = (order.items || []).map((i) => {
    if (i.separator) return "";
    const mods = [...(i.options || []), ...(i.modifiers || [])];
    return `<div class="it"><span class="q">${i.quantity}</span><span class="n">${i.name}${mods.length ? `<div class="mods">${mods.join(", ")}</div>` : ""}</span><span class="p">${money(i.price * i.quantity)}</span></div>`;
  }).join("");
  return `<div class="copy">
    <div class="center">
      ${s.logo_url ? `<img src="${s.logo_url}" class="logo"/>` : ""}
      <div class="biz">${s.business_name || "Mi Restaurante"}</div>
      ${s.address ? `<div class="muted">${s.address}</div>` : ""}
      ${s.phone ? `<div class="muted">Tel: ${s.phone}</div>` : ""}
      ${s.rfc ? `<div class="muted">RFC: ${s.rfc}</div>` : ""}
    </div>
    <hr class="solid"/>
    <div class="doc">${isAccount ? "CUENTA" : "TICKET DE VENTA"}</div>
    <div class="meta"><span>Fecha</span><span>${when.toLocaleDateString("es-MX")} ${when.toLocaleTimeString("es-MX", { hour: "2-digit", minute: "2-digit" })}</span></div>
    <div class="meta"><span>Folio</span><span>${(order.id || "").slice(0, 8).toUpperCase()}</span></div>
    <div class="meta"><span>Área</span><span>${AREA[order.order_type] || (order.order_type || "").toUpperCase()}${order.table ? ` · ${order.table}` : ""}</span></div>
    ${order.platform_order_id ? `<div class="meta"><span>ID Orden</span><span>${order.platform_order_id}</span></div>` : ""}
    ${isMesa && order.waiter_name ? `<div class="meta"><span>Mesero</span><span>${order.waiter_name}</span></div>` : ""}
    ${isMesa && order.num_clients ? `<div class="meta"><span>Personas</span><span>${order.num_clients}</span></div>` : ""}
    ${fulfillmentBlock(order)}
    ${isAccount ? `<div class="acct">CUENTA · NO PAGADO</div>` : ""}
    <hr/>
    <div class="thead"><span style="min-width:30px">CANT</span><span style="flex:1">PRODUCTO</span><span>IMPORTE</span></div>
    ${rows}
    <div class="box">
      <div class="sub row"><span>Artículos</span><span>${(order.items || []).reduce((a, i) => a + (i.separator ? 0 : i.quantity), 0)}</span></div>
      <div class="total"><span>TOTAL</span><span>${money(order.subtotal)}</span></div>
      ${paid ? `${(order.payments && order.payments.length)
        ? order.payments.map((p) => `<div class="pay"><span>${p.method}</span><span>${money(p.amount)}</span></div>`).join("")
        : (order.payment_method ? `<div class="pay"><span>Pago</span><span>${order.payment_method}</span></div>` : "")}
      ${order.received ? `<div class="pay"><span>Recibido</span><span>${money(order.received)}</span></div>` : ""}
      ${order.change ? `<div class="pay"><span>Cambio</span><span>${money(order.change)}</span></div>` : ""}` : ""}
    </div>
    <div class="foot">${s.ticket_footer || "¡Gracias por su compra!"}</div>
    ${qrBlock(s)}
    ${selfInvoiceBlock(s, order, paid)}
    ${copyLabel ? `<div class="copylbl">${copyLabel}</div>` : ""}
  </div>`;
}

export function ticketQrUrl(s) {
  if (!s || !s.ticket_qr_enabled) return "";
  if (s.ticket_qr_mode === "custom") return (s.ticket_qr_url || "").trim();
  return s.store_slug ? `${window.location.origin}/${s.store_slug}` : "";
}

// QR síncrono como SVG (sin red) para que el ticket se arme al instante.
function qrSvg(text) {
  try {
    const q = QRCode.create(text, { errorCorrectionLevel: "M" });
    const n = q.modules.size;
    const m = 2;
    let d = "";
    for (let y = 0; y < n; y += 1) for (let x = 0; x < n; x += 1) if (q.modules.get(x, y)) d += `M${x + m} ${y + m}h1v1h-1z`;
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${n + 2 * m} ${n + 2 * m}" shape-rendering="crispEdges" class="qr"><rect width="100%" height="100%" fill="#fff"/><path d="${d}" fill="#000"/></svg>`;
  } catch (e) { return ""; }
}

const PLATFORM_TYPES = ["ubereats", "didi", "rappi"];
function selfInvoiceBlock(s, order, paid) {
  if (!s?.selfinvoice_enabled || !s.store_slug || !paid || !order?.id || PLATFORM_TYPES.includes(order.order_type)) return "";
  const folio = order.id.slice(0, 8).toUpperCase();
  const total = (Number(order.subtotal) || 0) + (Number(order.delivery_cost) || 0);
  const url = `${window.location.origin}/factura/${s.store_slug}?f=${folio}&t=${total.toFixed(2)}`;
  const svg = qrSvg(url);
  if (!svg) return "";
  return `<div class="qrbox"><div class="qrtxt">Factura tu compra</div>${svg}<div class="qrurl">Folio: <b>${folio}</b> · Total ${money(total)}</div><div class="qrurl">${window.location.host}/factura/${s.store_slug}</div></div>`;
}

function qrBlock(s) {
  const url = ticketQrUrl(s);
  if (!url) return "";
  const svg = qrSvg(url);
  if (!svg) return "";
  return `<div class="qrbox"><div class="qrtxt">${s.ticket_qr_text || "¡Escanea y vuelve a pedir!"}</div>${svg}<div class="qrurl">${url.replace(/^https?:\/\//, "")}</div></div>`;
}

export function buildTicketHtml(settings, order, copies = 1) {
  const s = settings || {};
  const n = Math.max(1, Math.min(5, parseInt(copies, 10) || 1));
  const bodies = Array.from({ length: n }, (_, i) => ticketBody(s, order, n > 1 ? `Copia ${i + 1} de ${n}` : "")).join("");
  return `<html><head><title>Ticket</title><style>${ticketStyles(s.ticket_size || "80", s.ticket_font_size || "mediano")}</style></head><body>${bodies}</body></html>`;
}

export function buildCancelTicketHtml(settings, order) {
  const s = settings || {};
  const when = new Date(order.cancelled_at || Date.now());
  const rows = (order.items || []).filter((i) => !i.separator).map((i) => {
    const mods = [...(i.options || []), ...(i.modifiers || [])];
    return `<div class="it"><span class="q">${i.quantity}</span><span class="n">${i.name}${mods.length ? `<div class="mods">${mods.join(", ")}</div>` : ""}</span><span class="p">${money(i.price * i.quantity)}</span></div>`;
  }).join("");
  const body = `<div class="copy">
    <div class="center">
      ${s.logo_url ? `<img src="${s.logo_url}" class="logo"/>` : ""}
      <div class="biz">${s.business_name || "Mi Restaurante"}</div>
    </div>
    <hr class="solid"/>
    <div class="acct">PEDIDO CANCELADO</div>
    <div class="meta"><span>Folio</span><span>${(order.id || "").slice(0, 8).toUpperCase()}</span></div>
    <div class="meta"><span>Área</span><span>${AREA[order.order_type] || (order.order_type || "").toUpperCase()}${order.platform_order_id ? ` · ${order.platform_order_id}` : ""}</span></div>
    ${order.customer_name ? `<div class="meta"><span>Cliente</span><span>${order.customer_name}</span></div>` : ""}
    ${order.phone ? `<div class="meta"><span>Tel</span><span>${order.phone}</span></div>` : ""}
    <div class="meta"><span>Cancelado</span><span>${when.toLocaleDateString("es-MX")} ${when.toLocaleTimeString("es-MX", { hour: "2-digit", minute: "2-digit" })}</span></div>
    ${order.cancelled_by ? `<div class="meta"><span>Por</span><span>${order.cancelled_by}</span></div>` : ""}
    <hr/>
    <div class="thead"><span style="min-width:30px">CANT</span><span style="flex:1">PRODUCTO CANCELADO</span><span>IMPORTE</span></div>
    ${rows}
    <div class="box">
      <div class="total"><span>TOTAL CANCELADO</span><span>${money(order.subtotal)}</span></div>
      ${order.refund_cash > 0 ? `<div class="pay"><span>Devolución en efectivo</span><span>${money(order.refund_cash)}</span></div>` : ""}
    </div>
    <div class="tag">MOTIVO: ${order.cancel_reason || "—"}</div>
  </div>`;
  return `<html><head><title>Cancelación</title><style>${ticketStyles(s.ticket_size || "80", s.ticket_font_size || "mediano")}</style></head><body>${body}</body></html>`;
}

export function printTicket(settings, order, copies = 1) {
  openAndPrint(buildTicketHtml(settings, order, copies));
}

export function printComandas(settings, order) {
  const s = settings || {};
  const size = s.ticket_size || "80";
  const groups = {};
  expandCombos(order.items).forEach((i) => {
    if (i.separator) {
      Object.values(groups).forEach((g) => { if (g.length && !g[g.length - 1].separator) g.push(i); });
      return;
    }
    const st = i.station || "cocina";
    (groups[st] = groups[st] || []).push(i);
  });
  Object.values(groups).forEach((g) => { while (g.length && g[g.length - 1].separator) g.pop(); });
  const printerName = { cocina: s.printer_cocina, barra: s.printer_barra, caja: s.printer_caja };
  Object.entries(groups).forEach(([station, items]) => {
    if (station === "none") return;
    const rows = items.map((i) => {
      if (i.separator) return `<tr><td colspan="2"><div style="border-top:3px double #000;border-bottom:3px double #000;margin:6px 0;padding:2px 0;text-align:center;font-weight:900">— — SEPARAR PLATOS — —</div></td></tr>`;
      const mods = [...(i.options || []), ...(i.modifiers || [])];
      return `<tr><td class="q">${i.quantity}</td><td class="n">${i.name}${mods.length ? `<div class="mods">${mods.join(", ")}</div>` : ""}</td></tr>`;
    }).join("");
    const html = `<html><head><title>Comanda ${station}</title><style>${baseStyles(size)}</style></head><body>
      ${order.cancel ? `<div style="text-align:center;font-weight:900;font-size:1.5em;color:#000;border:3px solid #000;padding:5px 0;margin-bottom:5px">COMANDA CANCELADA</div>` : ""}
      <div class="tag">COMANDA · ${station.toUpperCase()}</div>
      ${order.cancel && order.cancel_reason ? `<div class="muted center"><b>Motivo:</b> ${order.cancel_reason}</div>` : ""}
      ${printerName[station] ? `<div class="muted center">Impresora: ${printerName[station]}</div>` : ""}
      <div class="muted">${new Date(order.created_at || Date.now()).toLocaleTimeString("es-MX")}</div>
      <div class="muted">Área: ${AREA[order.order_type] || (order.order_type||"").toUpperCase()}${order.table ? ` · Mesa ${order.table}` : ""}</div>
      ${order.platform_order_id ? `<div class="tag" style="margin-top:4px">ID ORDEN: ${order.platform_order_id}</div>` : ""}
      ${fulfillmentBlock(order)}
      <hr/>
      <table>${rows}</table>
    </body></html>`;
    openAndPrint(html);
  });
}
